import React from 'react';
// import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";
import {
	// Breadcrumb,
	// Card,
	// Row,
	// Col,
	// Input,
	// Button,
	// Table,
	// Modal,
	message,
	// Alert,
	// Select,
	// Tooltip,
	// Spin,
	// Form,
	// Skeleton
} from 'antd';

import moment from 'moment';

import Config from '../../Config';
import { Helmet } from "react-helmet";
import queryString from 'query-string';

import '../../assets/laporan.css';


const configClass = {
	title: 'LAPORAN SUM32',
	apiUrl: {
		preview: 'laporan/api/sum32/',
		userProfile: "auth/api/user/info"
	},

}

class LapSUM32Cetak extends React.Component {
	config;

	constructor(props) {
		super(props);
		this.config = new Config();
		this.state = {
			loading: false,
			data: null,
			err: false,

			// namauptppd: 'SAMSAT PALANGKARAYA',
		}

		// this.preview(this.props.match.params.id);

	}

	componentDidMount() {
		var uri_params = "";
		const uri_string = queryString.parse(this.props.location.search);
		for (var key in uri_string) {
			if (uri_params == "") {
				uri_params = "?" + key + "=" + uri_string[key];
			} else {
				uri_params += "&" + key + "=" + uri_string[key];
			}
		}
		this.preview(uri_params);
	}

	async preview(uri_params) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({
			loading: true,
			err: false,
			data: null,
		});

		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + uri_params)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({
						loading: false,
						data: data,
						err: false
					});
					setTimeout(function () {
						window.print();

					}, 1300);
				} else {
					const errTitle = 'error get laporan';
					this.setState({
						loading: false,
						data: null,
						err: true,
						errMsg: this.props.responseMsg
					});
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			}).catch((response) => {
				this.setState({
					loading: false,
					data: null,
					err: true,
					errMsg: 'unknown response'
				});
				console.log('gagal_get_laporan', response);
				message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	render() {
		// var total_pokok_bbnkb = 0;
		// var total_denda_bbnkb = 0;
		// var total_total_bbnkb = 0;

		// var total_pokok_pkb = 0;
		// var total_denda_pkb = 0;
		// var total_total_pkb = 0;

		// var total_pokok_swdkllj = 0;
		// var total_denda_swdkllj = 0;
		// var total_total_swdkllj = 0;

		var no = 0;
		return (
			<>
				<Helmet>
					<title>{configClass.title}</title>
				</Helmet>
				{(this.state.data != null &&
					<div className="kertas-laporan-besar">
						<div className="judul-laporan teks-tengah">
							BUKU PENERIMAAN HARIAN PKB, BBNKB, DAN SWDKLLJ<br />
							DI UPTPPD {this.state.data.summary.nama_samsat}<br />
						</div>
						<div className="judul-laporan">
							HARI, TANGGAL : {this.state.data.summary.hari_tanggal}<br />
						</div>
						<table className="laporan-table" border="1" cellPadding="5">
							<thead>
								<tr>
									<th rowspan="2">NO</th>
									<th rowspan="2" width={350}>NAMA <br />DAN ALAMAT PEMILIK</th>
									<th rowspan="2" width={80}>NO POLISI</th>
									<th colspan="3" >IDENTITAS KENDARAAN</th>
									<th rowspan="2" width={80}>JENIS <br />KENDARAAN</th>
									<th rowspan="2" width={80}>NO NOTICE <br />NO KOHIR <br /> NO SKUM</th>

									<th rowspan="2">
										POKOK PKB<br />
										DENDA PKB<br />
										JUMLAH PKB
									</th>

									<th rowspan="2">
										POKOK BBN I<br />
										DENDA BBN I<br />
										JUMLAH BBN I
									</th>

									<th rowspan="2">
										POKOK BBN II<br />
										DENDA BBN II<br />
										JUMLAH BBN II
									</th>

									<th rowspan="2">
										POKOK SWD<br />
										DENDA SWD<br />
										JUMLAH SWD
									</th>

									<th rowspan="2">
										OPSEN POKOK BBNKB<br />
									</th>

									<th rowspan="2">
										OPSEN POKOK PKB<br />
									</th>

									<th rowspan="2">
										JUMLAH POKOK<br />
										JUMLAH DENDA<br />
										JUMLAH SEMUA
									</th>
								</tr>
								<tr>
									<th width={150}>MEREK</th>
									<th width={70}>TAHUN</th>
									<th width={70}>CC</th>
								</tr>
							</thead>
							<tbody>
								{(
									// console.log(this.state.data.data.items)
									this.state.data != null && this.state.data.data.items.map((item, id) => (
									<>
										{/* <tr>
											<td colSpan={16} style={{ fontWeight: "bold" }}>{item.nama != null ? item.nama : "LAINNYA"}</td>
										</tr>  */}
										<tr>
											<td className="teks-tengah">{no += 1}</td>
											<td>
												{
													item.alamat_wp == null ? item.nama_wp : item.nama_wp
												}
												<br />
												{
													item.alamat_wp
												}
											</td>
											<td className="teks-tengah">
												{
													item.nopol.toUpperCase()
												}
												<br />
												{
													moment(item.masa_pajak_mulai).format('DD-MM-YYYY')
												}
											</td>
											<td>
												{
													item.merk_kendaraan
												}
												<br />
												{
													item.tipe_nama
												}
											</td>
											<td className="teks-tengah">
												{
													item.thn_buat
												}
											</td>
											<td className="teks-tengah">
												{
													item.silinder
												}
											</td>
											<td className="teks-tengah">
												{
													item.jenis_kendaraan
												}
											</td>
											<td className="teks-tengah">
												{
													item.no_notice
												}
											</td>
											<td className="teks-kanan">
												{
													(item.pokok_pkb).toLocaleString('id')
												}
												<br />
												{
													(item.denda_pkb).toLocaleString('id')
												}<br />
												{
													((item.pokok_pkb+item.denda_pkb)).toLocaleString('id')
												}
											</td>
											
											<td className="teks-kanan">
												{
													(item.pokok_bbnkb_i).toLocaleString('id')
												}
												<br />
												{
													(item.denda_bbnkb_i).toLocaleString('id')
												}<br />
												{
													((item.pokok_bbnkb_i+item.denda_bbnkb_i)).toLocaleString('id')
												}
											</td>

											<td className="teks-kanan">
												{
													(item.pokok_bbnkb_ii).toLocaleString('id')
												}
												<br />
												{
													(item.denda_bbnkb_ii).toLocaleString('id')
												}<br />
												{
													((item.pokok_bbnkb_ii+item.denda_bbnkb_ii)).toLocaleString('id')
												}
											</td>

											<td className="teks-kanan">
												{
													(item.pokok_swdkllj).toLocaleString('id')
												}
												<br />
												{
													(item.denda_swdkllj).toLocaleString('id')
												}<br />
												{
													((item.pokok_swdkllj+item.denda_swdkllj)).toLocaleString('id')
												}
											</td>

											<td className="teks-kanan">
												{
													(item.opsen_bbnkb).toLocaleString('id')
												}<br /><br /><br />
											</td>

											<td className="teks-kanan">
												{
													(item.opsen_pkb).toLocaleString('id')
												}<br /><br /><br />
											</td>

											<td className="teks-kanan">
												{
													(item.jumlah_pokok+item.opsen_pkb+item.opsen_bbnkb).toLocaleString('id')
												}
												<br />
												{
													(item.jumlah_denda).toLocaleString('id')
												}<br />
												{
													(item.jumlah_semua+item.opsen_pkb+item.opsen_bbnkb).toLocaleString('id')
												}
											</td>
										</tr>
										
									</>
									
								))
								)}
									<tr>
										<td colSpan={13}></td>
									</tr>
									<tr>
										<td colSpan={8} className='teks-kanan'>
											JUMLAH TANGGAL {this.state.data.summary.jum_tgl_sd}
										</td>

										<td className='teks-kanan'>
											{this.state.data.summary.pkb_pokok.toLocaleString('id')}<br />
											{this.state.data.summary.pkb_denda.toLocaleString('id')}<br />
											{(this.state.data.summary.pkb_pokok+this.state.data.summary.pkb_denda).toLocaleString('id')}
										</td>
										<td className='teks-kanan'>
											{this.state.data.summary.pokok_bbn_i.toLocaleString('id')}<br />
											{this.state.data.summary.denda_bbn_i.toLocaleString('id')}<br />
											{(this.state.data.summary.pokok_bbn_i+this.state.data.summary.denda_bbn_i).toLocaleString('id')}
										</td>
										<td className='teks-kanan'>
											{this.state.data.summary.pokok_bbn_ii.toLocaleString('id')}<br />
											{this.state.data.summary.denda_bbn_ii.toLocaleString('id')}<br />
											{(this.state.data.summary.pokok_bbn_ii+this.state.data.summary.denda_bbn_ii).toLocaleString('id')}
										</td>
										<td className='teks-kanan'>
											{this.state.data.summary.swdkllj_pokok.toLocaleString('id')}<br />
											{this.state.data.summary.swdkllj_denda.toLocaleString('id')}<br />
											{(this.state.data.summary.swdkllj_pokok+this.state.data.summary.swdkllj_denda).toLocaleString('id')}
										</td>
										<td className='teks-kanan'>
											{this.state.data.summary.opsen_bbnkb.toLocaleString('id')}<br />
											
										</td>
										<td className='teks-kanan'>
											{this.state.data.summary.opsen_pkb.toLocaleString('id')}<br />
											
										</td>
										<td className='teks-kanan'>
											{
												(
													this.state.data.summary.pkb_pokok+
													this.state.data.summary.pokok_bbn_i+
													this.state.data.summary.pokok_bbn_ii+
													this.state.data.summary.swdkllj_pokok+
													this.state.data.summary.opsen_bbnkb+
													this.state.data.summary.opsen_pkb
												).toLocaleString('id')
											}<br />
											{
												(
													this.state.data.summary.pkb_denda+
													this.state.data.summary.denda_bbn_i+
													this.state.data.summary.denda_bbn_ii+
													this.state.data.summary.swdkllj_denda
												).toLocaleString('id')
											}<br />
											{
												(
													(
														this.state.data.summary.pkb_pokok+
														this.state.data.summary.pokok_bbn_i+
														this.state.data.summary.pokok_bbn_ii+
														this.state.data.summary.swdkllj_pokok
													)
													+
													(
														this.state.data.summary.pkb_denda+
														this.state.data.summary.denda_bbn_i+
														this.state.data.summary.denda_bbn_ii+
														this.state.data.summary.swdkllj_denda
													)+
													(
														this.state.data.summary.opsen_bbnkb+
														this.state.data.summary.opsen_pkb
													)
												).toLocaleString('id')
											}
										</td>
									</tr>
							</tbody>
							{(this.state.data != null &&
								<tfoot>
								</tfoot>
							)}
						</table>
						<br />
						<br />
						<table border="0" cellPadding="5">
							<tbody>
								<tr>
									<td colSpan={7}>
										REKAPITULASI JUMLAH KENDARAAN
									</td>
								</tr>
								<tr>
									<td width={250}>
										{(
											this.state.data != null && this.state.data.data.rekap.map((item, id) => (
											<>
												{
													item.rek_jenis
												}<br/>
											</>
											))
										)}
									</td>
									<td width={10}>
										{(
											this.state.data != null && this.state.data.data.rekap.map((item, id) => (
											<>
												{
													item.rek_batas
												}<br/>
											</>
											))
										)}
									</td>
									<td width={200}>
										{(
											this.state.data != null && this.state.data.data.rekap.map((item, id) => (
											<>
												{
													item.rek_jum
												}<br/>
											</>
											))
										)}
									</td>
									<td width={400}></td>
									<td width={150}>
										{this.state.data.summary.jum_kend1}<br/>
										{this.state.data.summary.jum_pkb1}<br/>
										{this.state.data.summary.jum_swd1}<br/>
									</td>
									<td width={10}>
										{this.state.data.summary.jum_kend2}<br/>
										{this.state.data.summary.jum_pkb2}<br/>
										{this.state.data.summary.jum_swd2}<br/>
									</td>
									<td width={200}>
										{this.state.data.summary.jum_kend3}<br/>
										{this.state.data.summary.jum_pkb3}<br/>
										{this.state.data.summary.jum_swd3}<br/>
									</td>
								</tr>
							</tbody>
						</table>
						<br/>
						<br/>
						<table>
							<tbody>
								<tr className='teks-tengah'>
									<td>
										Mengetahui,<br />
										{this.state.data.ttd.kiri.jabatan}
									</td>
									<td>
										<br/>
										{this.state.data.ttd.tengah.jabatan}
									</td>
									<td>
										{this.state.data.ttd.tgl_tempat}
										<br/>
										{this.state.data.ttd.kanan.jabatan}
									</td>
								</tr>
								<br />
								<br />
								<br />
								<tr className='teks-tengah' cellPadding="5" >
									<td>
										<b>
											{this.state.data.ttd.kiri.nama}
										</b>
									</td>
									<td>
										<b>
											{this.state.data.ttd.tengah.nama}
										</b>
									</td>
									<td>
										<b>
											{this.state.data.ttd.kanan.nama}
										</b>
									</td>
								</tr>
								<tr className='teks-tengah'>
									<td>
										{this.state.data.ttd.kiri.nip}
									</td>
									<td>
										{this.state.data.ttd.tengah.nip}
									</td>
									<td>
										{this.state.data.ttd.kanan.nip}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				)}
			</>
		)
	}

}

const mapStateToProps = function (state) {
	return state.configReducers
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler,
	}
)(LapSUM32Cetak);